export enum RuleSortEnum {
    NEWEST = 'newest',
    POPULAR = 'popular',
}